/* codex-lume-warranty-heading-6-years-standalone-asset-20260727 start */
(function () {
  if (window.__codexlumewarrantyheading6yearsstandaloneasset20260727) return;
  window.__codexlumewarrantyheading6yearsstandaloneasset20260727 = true;
  if (!/^\/pages\/lume-kf0[123]-technical-v4\/?$/i.test(window.location.pathname || '')) return;
  function apply() {
    document.querySelectorAll('.lp-tech-v2-warranty strong').forEach(function (element) {
      if ((element.textContent || '').trim().toLowerCase() === '6-year warranty') element.textContent = '6 years';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  apply();
  window.addEventListener('pageshow', apply);
  window.setTimeout(apply, 250);
  window.setTimeout(apply, 1200);
})();
/* codex-lume-warranty-heading-6-years-standalone-asset-20260727 end */
